import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';
import { Logo } from './Logo';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const serviceAreas = [
    'Greater Austin Area',
    'West Lake Hills',
    'Buda',
    'Pflugerville',
    'Hutto',
    'Georgetown',
    'Steiner Ranch',
    'Leander',
    'Cedar Park'
  ];

  return (
    <footer className="bg-brand-navy text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        {/* Main Footer Content */}
        <div className="py-16 md:py-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="mb-6">
              <div className="flex items-center gap-2">
                <div className="w-10 h-10 bg-white rounded-lg flex items-center justify-center">
                  <span className="font-heading font-bold text-brand-navy text-lg">A</span>
                </div>
                <div>
                  <span className="font-heading font-bold text-white text-lg">ACH</span>
                  <p className="text-slate-400 text-xs">Cleaning Co.</p>
                </div>
              </div>
            </div>
            <p className="text-slate-300 font-body text-sm leading-relaxed mb-6">
              Professional cleaning services for residential and commercial properties across the Greater Austin Area.
            </p>
            <div className="space-y-3">
              <a 
                href="tel:512-563-4371" 
                className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors"
                data-testid="footer-phone"
              >
                <Phone className="w-4 h-4" />
                <span className="font-body text-sm">512-563-4371</span>
              </a>
              <a 
                href="mailto:ACH.CleaningCo@gmail.com" 
                className="flex items-center gap-3 text-slate-300 hover:text-white transition-colors"
                data-testid="footer-email"
              >
                <Mail className="w-4 h-4" />
                <span className="font-body text-sm">ACH.CleaningCo@gmail.com</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-white text-base mb-6">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-slate-300 hover:text-white font-body text-sm transition-colors" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-300 hover:text-white font-body text-sm transition-colors" data-testid="footer-link-about">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-300 hover:text-white font-body text-sm transition-colors" data-testid="footer-link-services">
                  Our Services
                </Link>
              </li>
              <li>
                <Link to="/projects" className="text-slate-300 hover:text-white font-body text-sm transition-colors" data-testid="footer-link-projects">
                  Projects
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading font-semibold text-white text-base mb-6">Services</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/services" className="text-slate-300 hover:text-white font-body text-sm transition-colors">
                  Residential Cleaning
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-300 hover:text-white font-body text-sm transition-colors">
                  Deep Cleaning
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-300 hover:text-white font-body text-sm transition-colors">
                  Post-Construction
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-slate-300 hover:text-white font-body text-sm transition-colors">
                  Commercial Cleaning
                </Link>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="font-heading font-semibold text-white text-base mb-6">
              <MapPin className="w-4 h-4 inline mr-2" />
              Service Areas
            </h4>
            <div className="flex flex-wrap gap-2">
              {serviceAreas.map((area) => (
                <span 
                  key={area}
                  className="px-3 py-1 bg-slate-800 rounded-full text-slate-300 font-body text-xs"
                >
                  {area}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-slate-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 font-body text-sm">
              &copy; {currentYear} ACH Cleaning Company. All rights reserved.
            </p>
            <p className="text-slate-500 font-body text-xs">
              Owned and operated by Maria Chiman
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
